var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95527 9.13232C10.248 9.4251 10.248 9.90014 9.95527 10.1929C9.66249 10.4858 9.18745 10.4857 8.89464 10.1929L5.20214 6.47295L1.48339 10.1917C1.19061 10.4845 0.715578 10.4845 0.422766 10.1917C0.129953 9.89892 0.129984 9.42388 0.422766 9.13107L4.14277 5.41357L0.421734 1.6667C0.128953 1.37392 0.128953 0.898885 0.421734 0.606072C0.714516 0.31326 1.18955 0.313291 1.48236 0.606072L5.20214 4.3542L8.92089 0.635447C9.21367 0.342666 9.6887 0.342666 9.98152 0.635447C10.2743 0.928228 10.2743 1.40326 9.98152 1.69607L6.26152 5.41357L9.95527 9.13232Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f47f677d8d41dcf37110e1ba736bcc46.svg";
export { ForwardRef as ReactComponent };